import { Pipe, PipeTransform } from '@angular/core';
import {formatCurrency, formatNumber, getCurrencySymbol} from "@angular/common";

@Pipe({
  name: 'customCurrencyPipe'
})
export class CustomCurrencyPipe implements PipeTransform {

  transform(
    value: number,
    currencyCode: string,
    digitsInfo: string = '1.2-2',
    display:
      | string
      | boolean = 'symbol-narrow',
    locale: string = 'en-US',
  ): string | null {

    if(currencyCode == 'MKD'){
      return `${formatNumber(value, 'en-US', digitsInfo)} Den`
    }
    return formatCurrency(
      value,
      locale,
      getCurrencySymbol(currencyCode, 'wide'),
      currencyCode,
      digitsInfo,
    );
  }

}
